import { connect } from 'react-redux';
import { setIsNavHidden } from 'navigation/navigationSlice';
import TitleBar from './TitleBar';

const mapState = () => ({});

const mapDispatch = {
  setIsNavHidden,
};

export default connect(mapState, mapDispatch)(TitleBar);
